import {
  ApiConnection, PfDTO, PfIndexResource, PfUserResource, User,
} from 'pfapi';

/**
 * Created by Marcus on 13.03.2017.
 */

export class PfUserIndexResource extends PfIndexResource<User> {

  constructor() {
    super("/user");
    // Wir brauchen in jedem Fall nur die aktiven Mitarbeiter
    this.addQueryParam("loginactive", 1);
    this.addMatrixParam("limit", "500");
    this.addMatrixParam("sort", "caption");
  }

  loadWithchilds(apiConnection: ApiConnection, a?): Promise<PfIndexResource<User>> {      // Überschreiben der Klasse, da wir unseren paramether bereits wissen.

    // return super.loadWithchilds<PfUserResource>(apiConnection, PfUserResource, true);

    let _e = this.apiData._etag;

    return super.load(apiConnection).then((indexResource: PfIndexResource<User>) => {
      // if(_e && indexResource.apiData._etag.value && _e.value == indexResource.apiData._etag.value){
      if(_e && indexResource.apiData._etag && _e == indexResource.apiData._etag){
        return indexResource;
      } else {
        if (indexResource.apiData.items) {
          for (const item of indexResource.apiData.items) {
            item.href = item.href + ';lck=' + PfUserIndexResource.hashCode(item.lastModifiedDate);
          }
        }
        return this.loadChildsLateResolve<PfUserResource>(apiConnection, PfDTO, PfUserResource);
      }
    });
  }

  private static hashCode(str) {
    // tslint:disable-next-line:no-bitwise
    return str.split('').reduce((prevHash, currVal) => (((prevHash << 5) - prevHash) + currVal.charCodeAt(0)) | 0, 0);
  }
}
